import { render, staticRenderFns } from "./InvestorProjectEvents.vue?vue&type=template&id=7a10df56&scoped=true&"
import script from "./InvestorProjectEvents.vue?vue&type=script&lang=js&"
export * from "./InvestorProjectEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10df56",
  null
  
)

export default component.exports